var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 2) scale(1.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9987 5.91536H5.66536V9.2487C5.66536 9.61537 5.36536 9.91537 4.9987 9.91537C4.63203 9.91537 4.33203 9.61537 4.33203 9.2487V5.91536H0.998698C0.632031 5.91536 0.332031 5.61536 0.332031 5.2487C0.332031 4.88203 0.632031 4.58203 0.998698 4.58203H4.33203V1.2487C4.33203 0.882031 4.63203 0.582031 4.9987 0.582031C5.36536 0.582031 5.66536 0.882031 5.66536 1.2487V4.58203H8.9987C9.36537 4.58203 9.66537 4.88203 9.66537 5.2487C9.66537 5.61536 9.36537 5.91536 8.9987 5.91536Z",
    fill: "#0065B3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusTooltip);
export default __webpack_public_path__ + "static/media/icon-plus-tooltip.768ae658b4b7760e3687a1f70d06cd46.svg";
export { ForwardRef as ReactComponent };